query InvoiceSigningSearchFilterTotals(
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $invoiceSigningSearchSearchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $isSearchAllData: Boolean
  $filterAccountingPeriodId: UUID
  $filterBusinessUnitId: UUID
  $filterCompanyId: UUID
  $filterCreatedById: UUID
  $filterCurrencyId: Int
  $filterDepartmentId: UUID
  $filterStatusTypeId: Int
  $filterTransactionTypeId: Int
  $filterMultiStatusTypes: [Int]
  $filterSupplierId: UUID
) {
  invoiceSigningSearchFilterTotals(
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSearchAllData: $isSearchAllData
    isSigningSearch: $isSigningSearch
    searchRequest: $invoiceSigningSearchSearchRequest
    filterDepartmentId: $filterDepartmentId
    filterAccountingPeriodId: $filterAccountingPeriodId
    filterBusinessUnitId: $filterBusinessUnitId
    filterCompanyId: $filterCompanyId
    filterCreatedById: $filterCreatedById
    filterCurrencyId: $filterCurrencyId
    filterStatusTypeId: $filterStatusTypeId
    filterTransactionTypeId: $filterTransactionTypeId
    filterMultiStatusTypes: $filterMultiStatusTypes
    filterSupplierId: $filterSupplierId
  ) {
    totalAmount1
    totalAmount2
    totalAmount3
    totalCount1
  }
}
